import { render, staticRenderFns } from "./ChargeDetail.vue?vue&type=template&id=5d76b01a&scoped=true"
import script from "./ChargeDetail.vue?vue&type=script&lang=js"
export * from "./ChargeDetail.vue?vue&type=script&lang=js"
import style0 from "./ChargeDetail.vue?vue&type=style&index=0&id=5d76b01a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d76b01a",
  null
  
)

export default component.exports